module.exports = __webpack_public_path__ + "static/media/tvshows-originals-banner.20acdfac.png";